angular.module( 'acme.view.application.layouts.tickets', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.tickets.list',
  'acme.view.application.layouts.tickets.create',
  'acme.view.application.layouts.tickets.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsTickets = {
        name: 'application.layouts.tickets',
        url: '/tickets',
        abstract: true,
        views: {
          "subview-main": {
            controller: 'LayoutsTicketsController',
            templateUrl: 'views/application/views/layouts/tickets/tickets.tpl.html'
          }
        }
      };

    $stateProvider
      .state(layoutsTickets);
});
